var p,
  m,
  g,
  v = 0;
jQuery("#contact_form").attr("id", "")
function splitLines() {
  let splitLines = jQuery("[data-line]");
  splitLines.each(function (i, j) {
    let x = new SplitText(j, {
      type: j.getAttribute("data-line"),
      linesClass: "line",
      wordsClass: "word",
      charsClass: "char",
    });
    let delay = j.getAttribute("data-delay");

    x.words.forEach((ele, index) => {
      if (delay) {
        gsap.to(ele, { "--delay": index + Number(delay) + "s" });
      } else {
        gsap.to(ele, { "--delay": index + "s" });
      }
    });
  });
  let splitLines2 = jQuery("[data-line-no-animation]");
  splitLines2.each(function (i, j) {
    new SplitText(j, {
      type: j.getAttribute("data-line-no-animation"),
      linesClass: "line",
      wordsClass: "word",
      charsClass: "char",
    });
  });

  let splitLines3 = jQuery("[data-line-within-line]");
  splitLines3.each(function (i, j) {
    let x = new SplitText(j, { type: "lines", linesClass: "line-mask" });
    new SplitText(jQuery(j).find(".line-mask"), {
      type: "lines",
      linesClass: "line-inner",
    });
    let delay = j.getAttribute("data-delay");

    x.lines.forEach((ele, index) => {
      if (delay) {
        let delaytamp = index + parseInt(delay);
        gsap.to(ele, { "--delay": delaytamp + "s" });
      } else {
        gsap.to(ele, { "--delay": index + "s" });
      }
    });
  });
}
function animations() {
  window.timeline = gsap.timeline({
    scrollTrigger: {
      trigger: "[data-scroll-container]",
      scrub: true,
      scroller: "[data-scroll-container]",
      start: "top top",
      end: "+=100%",
    },
  });
  window.u_tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".product-steps-new",
      scrub: true,
      scroller: "[data-scroll-container]",
      start: "top top",
      end: "+=400%",
      pin: true
    },
  });
  if (jQuery(".about-hero").length >= 1 && jQuery(window).width() > 1200) {
    if (!window.mobileAndTabletCheck()) {
      gsap.to(".about-hero", {
        scrollTrigger: {
          trigger: ".about-hero",
          scroller: "[data-scroll-container]",
          scrub: true,
          start: "top top",
          end: "+=100%",
          pin: true,
        },
        scale: 0.7,
        opacity: 0,
        ease: "none",
      });
    }
  }
  if (jQuery(".product-hero").length >= 1) {
    if (!window.mobileAndTabletCheck()) {
      gsap.to(".product-hero", {
        scrollTrigger: {
          trigger: ".product-hero",
          scroller: "[data-scroll-container]",
          scrub: true,
          start: "top top",
          end: "+=100%",
          pin: true,
        },
        scale: 0.8,
        opacity: 0,
        yPercent: -20,
        ease: "none",
      });
    }
  }
  if (jQuery(".lab-test").length >= 1 && jQuery(window).width() > 1200) {
    gsap.to(".lab-test", {
      scrollTrigger: {
        trigger: ".lab-test",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top+=30%",
        end: "+=150%",
      },
      ease: "none",
      scale: 0.8,
      opacity: 0,
    });
    if (jQuery(window).width() > 1200) {
      jQuery(".lab-test-c").height(jQuery(".lab-test").innerHeight());
    }
  }
  if (
    jQuery(".page-template-partnership").length >= 1 &&
    jQuery(window).width() > 1200
  ) {
    let testimonialsScroller = gsap.to(".testimonials", {
      scrollTrigger: {
        trigger: ".testimonials",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top+=40%",
        end: "+=100%",
        pin: true,
      },
      ease: "none",
      scale: 0.8,
      yPercent: -30,
      opacity: 0,
    });
    gsap.to(".testimonials-c", {
      scrollTrigger: {
        trigger: ".testimonials-c",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: testimonialsScroller.scrollTrigger.start,
        end: testimonialsScroller.scrollTrigger.end,
      },
      ease: "none",
      background: "#000",
    });
  }
  if (jQuery(".gallery-c").length >= 1 && jQuery(window).width() > 1200) {
    gsap.to(".gallery-c .gallery", {
      scrollTrigger: {
        trigger: ".gallery-c .gallery",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top+=80%",
        end: "+=100%",
        pin: true,
      },
      ease: "none",
      scale: 0.8,
      opacity: 0,
    });
  }
  if (
    jQuery(".career-at-knowsmoke-c").length >= 1 &&
    jQuery(window).width() >= 1200
  ) {
    // let career_footer =  gsap.to(".career-at-knowsmoke-c",{
    //     scrollTrigger: {
    //         trigger: ".career-at-knowsmoke-c",
    //         scroller:"[data-scroll-container]",
    //         scrub: true,
    //          start: "top bottom",
    //         end: "bottom top"
    //     },
    //     ease: "none",
    // });

    let footer_start = gsap.to(".page-template-career .banner-section", {
      scrollTrigger: {
        trigger: ".page-template-career .banner-section",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top top",
        end: "+=100%",
        pin: true,
      },
      ease: "none",
      scale: 0.7,
      opacity: 0,
    });
  }
  if (jQuery(".dealer-slider").length >= 1 && jQuery(window).width() > 1200) {
    let dealer_slider_area = jQuery(".dealer-slider").width();
    let singleSlideLength = jQuery(".dealer-slider .slide").length;
    let singleSlideswidth = jQuery(".dealer-slider .slide").width();
    let totalSlideswidth = (singleSlideswidth + 40) * singleSlideLength;
    let slidableArea = totalSlideswidth - dealer_slider_area;

    gsap.to(".dealer-slider", {
      scrollTrigger: {
        trigger: ".dealers-slider",
        scrub: true,
        scroller: "[data-scroll-container]",
        start: "top top",
        end: "+=100%",
        pin: true,
      },
      ease: "none",
      x: -slidableArea,
    });
  }
  if (jQuery(".partner-form").length >= 1) {
    gsap.to(".partner-form .background", {
      scrollTrigger: {
        trigger: ".partner-form",
        scrub: true,
        scroller: "[data-scroll-container]",
        start: "top bottom",
        end: "+=100%",
      },
      ease: "none",
      // clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
    });
  }
  window.tl = gsap.timeline();
  window.homeTL = gsap.timeline();

  if (jQuery(window).width() > 1200) {
    window.homeVideo = gsap.to([".home-hero"], {
      scrollTrigger: {
        trigger: ".home-hero",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top top",
        end: "100%",
      },
      ease: "none",
    });
    gsap.to([".home-hero video"], {
      scrollTrigger: {
        trigger: ".home-hero video",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: homeVideo.scrollTrigger.start,
        end: homeVideo.scrollTrigger.end,
        pin: true,
      },
      scale: 0.6,
      opacity: 0,
      yPercent: -20,
      ease: "none",
    });
  }
  // let step_slider = gsap.to([".steps"], {
  //   scrollTrigger: {
  //     trigger: ".steps",
  //     scroller: "[data-scroll-container]",
  //     scrub: true,
  //     start: "top top",
  //     end: "+=200%",
  //     pin:true
  //   },
  //   ease: "none",
  // });
  // gsap.to([".steps .container"], {
  //   scrollTrigger: {
  //     trigger: ".steps .container",
  //     scroller: "[data-scroll-container]",
  //     scrub: true,
  //     start: "0 0",
  //     end: "100% 100%",
  //   },
  //   ease: "none",
  // });
  
  if (jQuery(window).width() > 1200) {
    window.home_slider_scroller = gsap.to([".home-hero-slider"], {
      scrollTrigger: {
        trigger: ".home-hero-slider",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: homeVideo.scrollTrigger.start,
        end: homeVideo.scrollTrigger.end,
        pin: true,
      },
      ease: "none",
    });
    window.home_slider_scroller2 = gsap.to([".homepage-hero-cont"], {
      scrollTrigger: {
        trigger: ".homepage-hero-cont",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: homeVideo.scrollTrigger.start,
        end: homeVideo.scrollTrigger.end,
        pin: true,
      },
      ease: "none",
      scale: 0.8,
      opacity: 0,
      yPercent: -40,
      ease: "none",
    });
  }
  if (jQuery(window).width() >= 1200) {
    window.product_intro = gsap.to(".product-intro", {
      scrollTrigger: {
        trigger: ".product-intro",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top top",
        end: "+=100%",
      },
      ease: "none",
    });
    gsap.to(".product-intro .container", {
      scrollTrigger: {
        trigger: ".product-intro .container",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: window.product_intro.scrollTrigger.start,
        end: window.product_intro.scrollTrigger.end,
        pin: true,
      },
      ease: "none",
    });
  }
  if (jQuery(window).width() >= 1200) {
    window.scrollx.on("scroll", function () {
      if (window.product_intro) {
        if (
          window.product_intro.scrollTrigger.progress > 0 &&
          window.product_intro.scrollTrigger.progress <= 0.4
        ) {
          jQuery(".product-intro .content-slide").removeClass("active");
          jQuery(".product-intro .content-slide").removeClass("is-inview");
          jQuery(".product-intro .content-slide").eq(0).addClass("is-inview");
          jQuery(".product-intro .content-slide").eq(0).addClass("active");
        } else if (
          window.product_intro.scrollTrigger.progress > 0.4 &&
          window.product_intro.scrollTrigger.progress <= 0.8
        ) {
          jQuery(".product-intro .content-slide").removeClass("active");
          jQuery(".product-intro .content-slide").removeClass("is-inview");
          jQuery(".product-intro .content-slide").eq(1).addClass("active");
          jQuery(".product-intro .content-slide").eq(1).addClass("is-inview");
        } else if (window.product_intro.scrollTrigger.progress >= 1) {
          jQuery(".product-intro .content-slide").removeClass("active");
        }
      }
    });
  }
  const faqs = document.querySelectorAll(".accordion");

  faqs.forEach((accordion) => {
    accordion.addEventListener("click", () => {
      accordion.classList.toggle("active");
      setTimeout(() => {
        window.scrollx.update();
      }, 1000);
    });
  });
  if (jQuery(window).width() > 1200) {
    let tilt = gsap.to(".tilt-product-sec", {
      scrollTrigger: {
        trigger: ".tilt-product-sec",
        scroller: "[data-scroll-container]",
        scrub: true,
        start: "top top",
        end: "+=100%",
        pin: true,
      },
      ease: "none",
    });
  }
}
function preloader() {
  let target = { val: 0 };
  gsap.to(target, {
    duration: 3,
    val: 100,
    onUpdate: function () {
      jQuery(".counter--loader span").html(target.val.toFixed(0));
    },
  });
  setTimeout(() => {
    gsap.to(".loader-inner", 0.7, {
      opacity: 0,
      ease: "Expo.easeInOut",
    });
    gsap.to(".loader", 1.5, {
      rotate: 0.001,
      scale: 1,
      yPercent: -100,
      ease: "Expo.easeInOut",
    });
  }, 1000);
}
function headerAnimation() {
  jQuery(window).scroll(function (e) {
    if (jQuery(window).scrollTop() >= 400) {
      jQuery("header").addClass("hide");
    } else {
      jQuery("header").removeClass("hide");
    }
  });
  // if (jQuery(window).width() > 1200 && window.scrollx) {
  //   window.scrollx.on("scroll", function (e) {
  //     if (e.delta.y >= 700) {
  //       jQuery("header").addClass("hide");
  //     } else {
  //       jQuery("header").removeClass("hide");
  //     }
  //   });
  // }
}
function scrollAnimation() {
  window.scrollx = new LocomotiveScroll({
    el: document.querySelector("[data-scroll-container]"),
    smooth: false,
    mobile: {
      smooth: false,
    },
    tablet: {
      smooth: false,
    },
    getDirection: true,
  });

  if (jQuery(window).width() <= 1500 && jQuery(".page-template-science")) {
    window.scrollx.multiplier = 0.5;
  }
  window.scrollx.on("scroll", (args) => {
    document.querySelector("html").setAttribute("data-direction", args["direction"]);
  });

  ScrollTrigger.scrollerProxy("[data-scroll-container]", {
    scrollTop(value) {
      return arguments.length ? 0 : window.scrollx.scroll.instance.scroll.y;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
    pinType: document.querySelector("[data-scroll-container]").style.transform
      ? "transform"
      : "fixed",
  });
  window.scrollx.on("scroll", ScrollTrigger.update);
  window.mobileAndTabletCheck = function () {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  function T() {
    return !($(window).width() > 959);
  }

  function v(t) {
    return null !== t && "object" == typeof t;
  }

  function b(t) {
    // jQuery(".content-slide").removeClass("active")
    // jQuery(".content-slide").eq(jQuery(t).index()).addClass("active")
    $(t).length
      ? (window.scrollx.stop(),
        window.scrollx.scrollTo(t, {
          duration: 500,
          disableLerp: !1,
          callback: function () {
            var timeinterval = 2000;
            jQuery(".home-hero-slider .slide-item").removeClass("active");
            jQuery(".home-hero [data-scroll-x]").removeClass("is-inview");
            setTimeout(function () {
              (m = !1), window.scrollx.start();

              if (jQuery(t).index() == 1) {
                jQuery(".home-hero-slider .slide-item")
                  .eq(1)
                  .addClass("active");
              } else if (jQuery(t).index() == 2) {
                jQuery(".home-hero-slider .slide-item")
                  .eq(2)
                  .addClass("active");
              } else if (jQuery(t).index() == 3) {
                jQuery(".home-hero [data-scroll-x]").addClass("is-inview");
              }
            }, timeinterval);
          },
        }))
      : (v--, (m = !1));
  }
  function b2(t) {
    $(t).length
      ? (window.scrollx.stop(),
        window.scrollx.scrollTo(t, {
          duration: 500,
          disableLerp: !1,
          callback: function () {
            var timeinterval = 2500;
            jQuery(".product-steps .title-slides .step-heading").removeClass(
              "active"
            );
            jQuery(".product-steps .step-slider .step-desc li").removeClass(
              "active"
            );
            jQuery(".product-steps .owl-dots a").removeClass("active");
            if (jQuery(t).index() == 1) {
              document.querySelector(".steps video").currentTime = 0;
              setTimeout(() => {
                jQuery(".product-steps video").trigger("play");
              }, 500);
              timeinterval = 2500;
              jQuery(".product-steps .title-slides .step-heading")
                .eq(0)
                .addClass("active");
              jQuery(".product-steps .step-slider .step-desc li")
                .eq(0)
                .addClass("active");
              jQuery(".product-steps .owl-dots a").eq(0).addClass("active");
              setTimeout(() => {
                jQuery(".product-steps video").trigger("pause");
              }, timeinterval);
            } else if (jQuery(t).index() == 2) {
              document.querySelector(".product-steps video").currentTime = 2.5;
              setTimeout(() => {
                jQuery(".product-steps video").trigger("play");
              }, 500);
              timeinterval = 3500;
              jQuery(".product-steps .step-heading").eq(1).addClass("active");
              jQuery(".product-steps .step-desc li").eq(1).addClass("active");
              jQuery(".product-steps .owl-dots a").eq(1).addClass("active");
              setTimeout(() => {
                jQuery(".product-steps video").trigger("pause");
              }, timeinterval);
            } else if (jQuery(t).index() == 3) {
              document.querySelector(".product-steps video").currentTime = 6;
              setTimeout(() => {
                jQuery(".product-steps video").trigger("play");
              }, 500);
              timeinterval = 13000;
              jQuery(".product-steps .step-heading").eq(2).addClass("active");
              jQuery(".product-steps .step-desc li").eq(2).addClass("active");
              jQuery(".product-steps .owl-dot").eq(2).addClass("active");
              setTimeout(() => {
                jQuery(".product-steps video").trigger("pause");
              }, timeinterval);
            }
            setTimeout(function () {
              (m = !1), window.scrollx.start();
            }, 500);
          },
        }))
      : (v--, (m = !1));
  }
  window.b4 = (t) => {
    window.animateBody(jQuery(t).index());
    console.log(t)
    $(t).length
      ? (window.scrollx.stop(),
        window.scrollx.scrollTo(t, {
          duration: 100,
          disableLerp: !1,
          callback: function () {
            var timeinterval = 1500;
            if (window.animateBody) {
              window.animateBody(jQuery(t).index());
            }

            setTimeout(function () {
              (m = !1), window.scrollx.start();
            }, timeinterval);
          },
        }))
      : (v--, (m = !1));
    
  };
  function b3(t) {
    let scrollTargetElement = jQuery(t).attr("scroll-to");

    $(t).length
      ? (window.scrollx.stop(),
        window.scrollx.scrollTo(t, {
          duration: 100,
          disableLerp: !1,
          callback: function () {
            jQuery(".content-slide").removeClass("active");
            jQuery(scrollTargetElement).addClass("active");
            var timeinterval = 500;
            setTimeout(function () {
              (m = !1), window.scrollx.start();
            }, timeinterval);
          },
        }))
      : (v--, (m = !1));
  }

  var p,
    m,
    g,
    v = 0;
  function w(t) {
    t && !T() && $("html").hasClass("no-touch")
      ? p ||
      ((p = !0),
        $(".slide").bind("mousewheel DOMMouseScroll", function (t) {
          t.originalEvent.wheelDelta > 0 || t.originalEvent.detail < 0
            ? !m && v > 0 && ((m = !0), b(".slide" + --v))
            : m || ((m = !0), b(".slide" + ++v));
        }))
      : p && ((p = !1), $(".slide").unbind("mousewheel DOMMouseScroll"));
  }
  function w4(t) {
    
    t && !T() && $("html").hasClass("no-touch")
      ? p ||
      ((p = !0),
        $(".slide-body").bind("mousewheel DOMMouseScroll", function (t) {
          t.originalEvent.wheelDelta > 0 || t.originalEvent.detail < 0
            ? !m && v > 0 && ((m = !0), window.b4(".slide-body" + --v))
            : m || ((m = !0), window.b4(".slide-body" + ++v));
        }))
      : p && ((p = !1), $(".slide-body").unbind("mousewheel DOMMouseScroll"));
  }
  function w2(t) {
    t && !T() && $("html").hasClass("no-touch")
      ? p ||
      ((p = !0),
        $(".slide").bind("mousewheel DOMMouseScroll", function (t) {
          t.originalEvent.wheelDelta > 0 || t.originalEvent.detail < 0
            ? !m && v > 0 && ((m = !0), b2(".slide" + --v))
            : m || ((m = !0), b2(".slide" + ++v));
        }))
      : p && ((p = !1), $(".slide").unbind("mousewheel DOMMouseScroll"));
  }
  function w3(t) {
    t && !T() && $("html").hasClass("no-touch")
      ? p ||
      ((p = !0),
        $(".slidex").bind("mousewheel DOMMouseScroll", function (t) {
          t.originalEvent.wheelDelta > 0 || t.originalEvent.detail < 0
            ? !m && v > 0 && ((m = !0), b3(".slidex" + --v))
            : m || ((m = !0), b3(".slidex" + ++v));
        }))
      : p && ((p = !1), $(".slidex").unbind("mousewheel DOMMouseScroll"));
  }

  window.scrollx.on("call", (t, i, n) => {

    if ("enter" === i) {

      switch (t) {
        case "scrollGuidato":
          w(!0);
          break;
        case "scrollGuidato2":
          w2(!0);
          break;
        case "scrollGuidato3":
          w3(!0);
          break;
        case "scrollGuidato4":
          w4(!0);
          break;
        case "scrollGuidato5":
          window.animateBody(0);
          break;
        case "scrollGuidato6":
          window.animateBody(1);
          break;
        case "scrollGuidato7":
          window.animateBody(2);
          break;
          case "scrollGuidato8":
            window.animateBody(3);
            break;
        case "scrollNormale":
          w(!1);
          break;
        case "header-negative":
          $("body").addClass("negative");
          break;
        case "header-positive":
          $("body").removeClass("negative");
          break;
        case "animate_number":
          let elements = jQuery("[data-number]");

          let targets = [];
          for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let number = jQuery(element).attr("data-number");
            targets.push({ val: 0 });

            gsap.to(targets[i], {
              duration: 4,
              val: parseInt(number),
              onUpdate: function () {
                jQuery(element).html(targets[i].val.toFixed(0));
              },
            });
          }

          break;
      }
    }
  });
  if (
    jQuery(".science-stickyss").length >= 1 &&
    jQuery(window).width() > 1200
  ) {
    let step_slider_width =
      jQuery(".steps .step-slider").width() -
      jQuery(".steps .step-slider .step").width();
    let stepSlideLength = document.querySelectorAll(
      ".steps .step-slider .step"
    ).length;
    let $step_slider = gsap.to(".steps", {
      scrollTrigger: {
        trigger: ".steps",
        scrub: true,
        scroller: "[data-scroll-container]",
        start: "top top",
        end: "+=200%",
      },
      ease: "none",
    });

    window.scrollx.on("scroll", function (e) {
      let totalslideArea =
        $step_slider.scrollTrigger.end - $step_slider.scrollTrigger.start;
      let stepsSlides = jQuery(".steps  .title-slides .step-heading");
      let singleSlideTime = totalslideArea / stepsSlides.length;
      
      let x = ($step_slider.scrollTrigger.end - e.scroll.y) / singleSlideTime;
      if (x > 0 && x <= stepsSlides.length) {
        jQuery(".steps .title-slides .step-heading").removeClass("active");
        jQuery(".steps .title-slides2 .step-heading").removeClass("active");
        jQuery(".steps  .title-slides2 .step-heading")
          .eq(stepsSlides.length - 1 - Math.floor(x))
          .addClass("active");
        jQuery(".steps  .title-slides .step-heading")
          .eq(stepsSlides.length - 1 - Math.floor(x))
          .addClass("active");
        jQuery(".steps li").removeClass("active");
        jQuery(".steps li")
          .eq(stepsSlides.length - 1 - Math.floor(x))
          .addClass("active");
        jQuery(".steps .owl-dots a").removeClass("active");
        jQuery(".steps .step-img").removeClass("active");
        jQuery(".steps .owl-dots a")
          .eq(stepsSlides.length - 1 - Math.floor(x))
          .addClass("active");
        jQuery(".steps .step-img")
          .eq(stepsSlides.length - 1 - Math.floor(x))
          .addClass("active");
        if (e.direction == "up") {
          jQuery(".steps  .title-slides .step-heading")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps  .title-slides2 .step-heading")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps li")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps .owl-dots a")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps .step-img")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          if (x >= 1) {
            jQuery(".steps .title-slides .step-heading")
              .eq(stepsSlides.length - 1 - Math.floor(x))
              .removeClass("inactive");
            jQuery(".steps  .title-slides2 .step-heading")
              .eq(stepsSlides.length - 1 - Math.floor(x))
              .removeClass("inactive");
            jQuery(".steps li")
              .eq(stepsSlides.length - 1 - Math.floor(x))
              .removeClass("inactive");
            jQuery(".steps .owl-dots a")
              .eq(stepsSlides.length - 1 - Math.floor(x))
              .removeClass("inactive");
            jQuery(".steps .step-img")
              .eq(stepsSlides.length - 1 - Math.floor(x))
              .removeClass("inactive");
          }
        } else {
          jQuery(".steps  .title-slides .step-heading")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps .title-slides2 .step-heading")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps li")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps .owl-dots a")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");
          jQuery(".steps .step-img")
            .eq(stepsSlides.length - 1 - Math.floor(x))
            .addClass("active");

          if (x < stepsSlides.length - 1) {
            jQuery(".steps .title-slides .step-heading")
              .eq(stepsSlides.length - 2 - Math.floor(x))
              .addClass("inactive");
            jQuery(".steps .title-slides2 .step-heading")
              .eq(stepsSlides.length - 2 - Math.floor(x))
              .addClass("inactive");
            jQuery(".steps li")
              .eq(stepsSlides.length - 2 - Math.floor(x))
              .addClass("inactive");
            jQuery(".steps .owl-dots a")
              .eq(stepsSlides.length - 2 - Math.floor(x))
              .addClass("inactive");
            jQuery(".steps .step-img")
              .eq(stepsSlides.length - 2 - Math.floor(x))
              .addClass("inactive");
          }
        }
      }
    });
  }
  ScrollTrigger.addEventListener("refresh", () => window.scrollx.update());
  ScrollTrigger.refresh();
}
function callToBeOnce() {
  jQuery(document).on("click", ".footer-toggle", function (e) {
    jQuery(e.target).next(".link-data").slideToggle();
    jQuery(e.target).next(".link-data").toggleClass("active");
    jQuery(e.target).toggleClass("active");
  });
  window.addEventListener(
    "orientationchange",
    function () {
      if (window.orientation != 0) {
        jQuery(".rotate").addClass("show");
      } else {
        jQuery(".rotate").removeClass("show");
      }
    },
    false
  );
  jQuery(document).on("click", "i.more", function () {
    let input = jQuery(this).parent(".qty-container").find("input");
    let val = input.val();
    input.val(Number(val) + 1);
    input.attr("value", Number(val) + 1);
    setTimeout(() => {
      input.trigger("change");
    }, 200);
  });
  jQuery(document).on("click", "i.less", function () {
    let input = jQuery(this).parent(".qty-container").find("input");
    let val = input.val();
    input.val(Number(val) - 1);
    input.attr("value", Number(val) - 1);
    setTimeout(() => {
      input.trigger("change");
    }, 200);
  });

  if (jQuery(window).width() <= 844) {
    if (window.orientation != 0) {
      jQuery(".rotate").addClass("show");
    } else {
      jQuery(".rotate").removeClass("show");
    }
  }
  document.body.classList.add("loaded");
}
function scienceAnimation() {
  class Load3DModal {
    camera;
    scene;
    renderer;
    container;
    controls;
    scene;
    modal;
    pointsMaterial;
    humanpointsMaterial;
    group;
    clock;
    loader;
    dracoLoader;
    human;
    humanOpacity;
    humanpointsMaterialScale;
    productPageModal;
    Shadermaterialx;
    constructor(cont) {
      this.container = document.querySelector(cont);
      this.scene = new THREE.Scene();
      this.controls = "";
      this.pointsMaterial;
      this.humanpointsMaterial;
      this.group = new THREE.Object3D();
      this.clock = new THREE.Clock();
      this.loader = new THREE.GLTFLoader();
      this.dracoLoader = new THREE.DRACOLoader();
      this.dracoLoader.setDecoderConfig({ type: 'js' });
      this.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
      // this.dracoLoader.setDecoderPath(window.assets_url+"/js/draco/");
      this.loader.setDRACOLoader(this.dracoLoader);
      this.humanOpacity = 0;
      this.humanpointsMaterialScale = new THREE.Vector2(1.0, 1.0);
      this.pointRandomness = new THREE.Vector2(1, 1, 1);
      this.braincolor = new THREE.Vector2(1.0, 0.0);
      this.heartColor = new THREE.Vector2(1.0, 0.0);
      this.lungsColor = new THREE.Vector2(1.0, 0.0);
      this.bodyColor = new THREE.Vector3(0.1, 0.1, 0.1);
      this.productPageModal;
      this.Shadermaterialx;
      this.Shadermaterialcar;
      this.carSeatColor = new THREE.Vector4(1.0, 0.0, 0.0); // array[4];
      this.carAcColor = new THREE.Vector3(0.0, 0.05, 0.0); // array[2]
      this.tyreColor = new THREE.Vector3(1.0, 1.0, 1.0); // array[6]
      this.RoofTopColor = new THREE.Vector3(0.0, 0.05, 0.0); // array[5]
      this.carBottomColor = new THREE.Vector3(0.0, 0.05, 0.0); // array[3]
      this.carBodyColor = new THREE.Vector2(0.0, 1.0); // array[7]
      this.mouseX = 0;
      this.mousey = 0;
      this.targetX = 0;
      this.targetY = 0;
      this.windowHalfX = window.innerWidth / 2;
      this.windowHalfY = window.innerHeight / 2;
      this.stag = [];
    }

    init(modalName) {
      var _this = this;

      this.camera = new THREE.PerspectiveCamera(
        45,
        this.container.clientWidth / this.container.clientHeight,
        1,
        2000
      );
      this.camera.position.z = -250;
      window.ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
      this.scene.add(ambientLight);
      window.pointLight = new THREE.PointLight(0xffffff, 1);
      pointLight.position.set(10, 110, 100);
      const light = new THREE.DirectionalLight(0xffffff, 1);
      this.scene.add(light);
      this.camera.add(pointLight);
      this.scene.add(this.camera);
      var _this = this;
      _this.loader.load(
        modalName,
        function (object) {
          object = object.scene;
          const materialx = new THREE.MeshStandardMaterial({
            color: 0x050505,
            metalness: 0.1,
            roughness: 0.5,
          });
          object.position.set(10, -40, 0);
          object.rotation.set(-0.1, 0, -0.7);
          if (jQuery(".homepage-tilt-img") && jQuery(window).width() <= 1200) {
            object.rotation.set(0, 3.2, 0);
            object.position.y = -20;
            object.position.x = 0;
            object.traverse(function (node) {
              if (node.name == "modal001_3") {
                var map = new THREE.TextureLoader().load(
                  "//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/strip-2.jpg"
                );
                const materialz = new THREE.MeshBasicMaterial({
                  color: 0x000000,
                  transparent: true,
                  opacity: 0,
                });
                node.material = materialz;
              }

              if (node.name == "modal001_5") {
                var map = new THREE.TextureLoader().load(
                  '//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/ion-qr.jpg?v=51603981052309779021679038865'
                );
                const materialz = new THREE.MeshBasicMaterial({
                  color: 0xffffff,
                  transparent: true,
                  opacity: 1,
                  map: map,
                });
                node.material = materialz;
              }
            });
          }
          if (modalName != "logo") {
            object.traverse(function (obj) {
              if (obj.isMesh) obj.material = materialx;
            });
            window.modal = object;
          } else {
            const materialx = new THREE.MeshStandardMaterial({
              color: 0x888888,
              metalness: 1,
              roughness: 0.7,
            });
            object.traverse(function (obj) {
              if (obj.isMesh) obj.material = materialx;
            });
            window.footer_logo = object;
          }
          _this.scene.add(object);

          if (object) {
            if (jQuery(".contact-page-modal").length >= 1) {
              window.x = object;
              object.rotation.set(0, 0, 0.2);
              let contactTimeline = gsap.timeline();
              contactTimeline.to(object.rotation, {
                scrollTrigger: {
                  trigger: ".contact-hero",
                  scroller: "[data-scroll-container]",
                  scrub: true,
                  start: "top top",
                  end: "+=300%",
                },
                x: 0,
                y: 10,
                ease: "none",
              });
            }

            if (
              jQuery("#product360").length >= 1 &&
              jQuery(window).width() <= 767
            ) {
              object.rotation.set(0, 0, 0);
              object.position.set(0, -30, 0);
              object.scale.set(1.2, 1.2, 1.2);
            }
            if (
              jQuery(".picture-flex-inner").length >= 1 &&
              jQuery(window).width() > 1200
            ) {
              object.rotation.set(0, 6.15, 0.5);
              object.position.y = -200;
              object.position.x = 0;
              object.scale.set(0.7, 0.7, 0.7);
              let scrollHeight = jQuery(window).innerHeight();
              gsap.to(object.rotation, {
                scrollTrigger: {
                  trigger: ".knowsmoke-test-slider",
                  scroller: "[data-scroll-container]",
                  scrub: true,
                  start: window.product_intro.scrollTrigger.end - scrollHeight,
                  end: window.product_intro.scrollTrigger.end,
                },
                ease: "none",
                x: 0,
                y: 0,
                z: 0,
              });
              gsap.to(object.position, {
                scrollTrigger: {
                  trigger: ".product-intro",
                  scroller: "[data-scroll-container]",
                  scrub: true,
                  start: window.product_intro.scrollTrigger.end - scrollHeight,
                  end: window.product_intro.scrollTrigger.end,
                },
                ease: "none",
                x: 0,
                y: -20,
                z: 0,
              });
              gsap.to(".picture-flex-inner", {
                scrollTrigger: {
                  trigger: ".tilt-product-sec",
                  scroller: "[data-scroll-container]",
                  scrub: true,
                  start: window.product_intro.scrollTrigger.end,
                  end: "+=100%",
                },
                ease: "none",
                x: "-50%",
                z: 0,
                y: "0%",
              });
              gsap.fromTo(
                ".picture-flex-inner",
                { y: "0%" },
                {
                  scrollTrigger: {
                    trigger: "#universal-published",
                    scroller: "[data-scroll-container]",
                    scrub: true,
                    start: "top bottom",
                    end: "+=100%",
                  },
                  ease: "none",
                  y: "-130%",
                  z: 0,
                }
              );

              gsap.fromTo(
                object.rotation,
                {
                  x: 0,
                  y: 0,
                  z: 0,
                },
                {
                  scrollTrigger: {
                    trigger: ".tilt-product-sec",
                    scroller: "[data-scroll-container]",
                    scrub: true,
                    start: window.product_intro.scrollTrigger.end,
                    end: "+=100%",
                  },
                  ease: "none",
                  x: 0,
                  y: -3.25,
                  z: -0.3,
                }
              );
              gsap.fromTo(
                object.position,
                {
                  x: 0,
                  y: -20,
                  z: 0,
                },
                {
                  scrollTrigger: {
                    trigger: ".tilt-product-sec",
                    scroller: "[data-scroll-container]",
                    scrub: true,
                    start: knowsmokeSlider.scrollTrigger.end + 200,
                    end: "+=90%",
                  },
                  ease: "none",
                  x: 0,
                  y: -20,
                  z: 0,
                }
              );
            }
            _this.render();
          }
          if (object) {
            if (modalName == "https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb") {
              object.traverse(function (node) {
                if (node.name == "modal001_3") {
                  var map = new THREE.TextureLoader().load(
                    "//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/strip-2.jpg"
                  );
                  const materialz = new THREE.MeshBasicMaterial({
                    color: 0x000000,
                    transparent: true,
                    opacity: 0,
                  });
                  node.material = materialz;
                }
                if (node.name == "modal001_3") {
                  var map = new THREE.TextureLoader().load(
                    "//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/strip-2.jpg"
                  );

                  const materialz = new THREE.MeshBasicMaterial({
                    transparent: true,
                    opacity: 0.7,
                    map: map,
                  });

                  node.material = materialz;
                }
                if (node.name == "modal001_5") {
                  var map = new THREE.TextureLoader().load(
                    '//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/ion-qr.jpg?v=51603981052309779021679038865'
                  );
                  const materialz = new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    transparent: true,
                    opacity: 1,
                    map: map,
                  });
                  node.material = materialz;
                }
              });
              if (jQuery(".homepage-tilt-img").length >= 1) {
                object.position.set(0, -20, 0);
                object.rotation.set(0, 0, 0);
                window.animate_modal = object;
              }
              if (jQuery("#product360").length >= 1) {
                object.position.set(0, -20, 0);
                object.rotation.set(0, 0, 0);
              }
            }
          }
          if (object) {
            if (jQuery(".product-modal").length >= 1) {
              object.position.set(0, -20, 0);
              object.rotation.set(0, 0, 0);
            }
          }
        }
      );

      //   });

      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(
        this.container.clientWidth,
        this.container.clientHeight
      );
      this.container.appendChild(this.renderer.domElement);
      if (
        jQuery(".single-product").length >= 1 ||
        jQuery(".page-template-science").length >= 1
      ) {
        this.controls = new THREE.OrbitControls(
          _this.camera,
          _this.renderer.domElement
        );
        this.controls.enableDamping = true;
        this.controls.enableZoom = false;
        this.controls.rotateSpeed = 0.1;
        this.controls.dampingFactor = 0.05;
        this.controls.update();
        this.controls.enableKeys = false;
      }

      if (window.modal) {
      }
    }

    initWithParticle(modalNames) {
      var _this = this;
      window.animateBody = (i) => {
        if (i == 0) {
          gsap.to(_this.lungsColor, 0.5, { y: 1 });
          gsap.to(_this.braincolor, 0.5, { y: 0 });
          gsap.to(_this.heartColor, 0.5, { y: 0 });
          gsap.to(_this.bodyColor, 0.5, { x: 0.3, y: 0.3, z: 0.3 });
          jQuery(".indicators li").removeClass("active");
          jQuery(".indicators li").eq(0).addClass("active");
        } else if (i == 1) {
          gsap.to(_this.lungsColor, 0.5, { y: 0 });
          gsap.to(_this.braincolor, 0.5, { y: 1 });
          gsap.to(_this.heartColor, 0.5, { y: 0 });
          gsap.to(_this.bodyColor, 0.5, { x: 0.3, y: 0.3, z: 0.3 });
          jQuery(".indicators li").removeClass("active");
          jQuery(".indicators li").eq(1).addClass("active");
        } else if (i == 2) {
          gsap.to(_this.lungsColor, 0.5, { y: 0 });
          gsap.to(_this.braincolor, 0.5, { y: 0 });
          gsap.to(_this.heartColor, 0.5, { y: 1 });
          gsap.to(_this.bodyColor, 0.5, { x: 0.3, y: 0.3, z: 0.3 });
          jQuery(".indicators li").removeClass("active");
          jQuery(".indicators li").eq(2).addClass("active");
        } else if (i == 3) {
          gsap.to(_this.lungsColor, 0.5, { y: 0 });
          gsap.to(_this.braincolor, 0.5, { y: 0 });
          gsap.to(_this.heartColor, 0.5, { y: 0 });
          gsap.to(_this.bodyColor, 0.5, { x: 1.0, y: 0.4313, z: 0.0 });
          jQuery(".indicators li").removeClass("active");
          jQuery(".indicators li").eq(3).addClass("active");
        } else if (i == 4) {
          gsap.to(_this.lungsColor, 0.5, { y: 1 });
          gsap.to(_this.braincolor, 0.5, { y: 0 });
          gsap.to(_this.heartColor, 0.5, { y: 0 });
          gsap.to(_this.bodyColor, 0.5, { x: 0.3, y: 0.3, z: 0.3 });
        } else {
          gsap.to(_this.bodyColor, 0.5, { x: 0.3, y: 0.3, z: 0.3 });
        }
      };
      this.camera = new THREE.PerspectiveCamera(
        45,
        this.container.clientWidth / this.container.clientHeight,
        1,
        2000
      );
      this.camera = new THREE.OrthographicCamera(
        this.container.clientWidth / -2,
        this.container.clientWidth / 2,
        this.container.clientHeight / 2,
        this.container.clientHeight / -2,
        1,
        1000
      );
      this.camera.position.z = -250;
      this.camera.zoom = 5.5;
      this.camera.updateProjectionMatrix();
      window.ambientLight = new THREE.AmbientLight(0x000000, 0.4);
      window.pointLight = new THREE.PointLight(0x000000, 1);
      pointLight.position.set(10, 110, 100);
      const light = new THREE.DirectionalLight(0x000000, 1);
      const lightx = new THREE.HemisphereLight(0x000000, 0x080820, 1);
      _this.scene.add(lightx);
      this.scene.add(light);
      this.camera.add(pointLight);
      this.scene.add(this.camera);
      var _this = this;
      _this.scene.background = new THREE.Color(0xffffff);

      modalNames.forEach((modalName) => {
        _this.loader.load(
          modalName,
          function (gltf) {
            if (modalName == "Full_cell") {
              _this.scene.background = new THREE.Color(0xffffff);
              let sphereGeometryx = new THREE.SphereGeometry(40, 32, 16);
              const sphereMaterial = new THREE.MeshStandardMaterial({
                color: 0xff0000,
                opacity: 0.5,
                transparent: true,
              });
            }
            if (modalName == "mole") {
              let sphereGeometryx = new THREE.SphereGeometry(40, 32, 16);
              const sphereMaterial = new THREE.MeshStandardMaterial({
                color: 0x000000,
                opacity: 0.7,
                transparent: true,
              });
              let meshx = new THREE.Mesh(sphereGeometryx, sphereMaterial);
              meshx.scale.set(50, 50, 50);
              const sampler = new THREE.MeshSurfaceSampler(meshx).build();
              const vertices = [];
              const tempPosition = new THREE.Vector3();
              let particleRandomness = new Float32Array(50 * 3);
              for (let i = 0; i < 50; i++) {
                sampler.sample(tempPosition);
                vertices.push(tempPosition.x, tempPosition.y, tempPosition.z);
                particleRandomness.set(
                  [
                    Math.random() * 2 - 1,
                    Math.random() * 2 - 1,
                    Math.random() * 2 - 1,
                  ],
                  i * 3
                );
              }
              let particleGeometry = new THREE.BufferGeometry();
              particleGeometry.setAttribute(
                "position",
                new THREE.Float32BufferAttribute(vertices, 3)
              );
              particleGeometry.setAttribute(
                "aRandom",
                new THREE.Float32BufferAttribute(particleRandomness, 3)
              );
              window.molematerial = new THREE.ShaderMaterial({
                uniforms: {
                  uTime: { value: 0.1 },
                  uScale: { value: 100.0 },
                  uColor: { value: 0.75 },
                  uOpacity: { value: 0.75 },
                },
                vertexShader: ` attribute vec3 aRandom;
                                uniform float uTime;
                                uniform float uScale;
                                uniform float uColor;
                                varying vec3 vPosition;
                                void main() {
                                    vPosition = position;
                                    vec3 pos = position;
                                    float time = uTime * 0.5;
                                    pos.x += sin(time * aRandom.y) * uScale;
                                      pos.y += sin(time * aRandom.z) * uScale;
                                      pos.z += cos(time * aRandom.x) * uScale;
                                    vec4 mvPosition = modelViewMatrix * vec4(pos,1.0);
                                    gl_Position = projectionMatrix * mvPosition;
                                    gl_PointSize = 3.0;
                                }`,
                fragmentShader: `varying vec3 vPosition;
                                uniform float uTime;
                                uniform float uColor;
                                uniform float uOpacity;
                                void main() {
                                     vec3 color = vec3(1.0,1.0,1.0); 
                                     color.r = 0.5;
                                     color.g = 0.5;
                                     color.b = 0.5;
                                    gl_FragColor = vec4(color,1.0); }`,
                derivatives: true,
                //blending:THREE.AdditiveBlending,
                depthWrite: false,
                transparent: true,
                opacity: 0,
                side: THREE.DoubleSide,
              });
              var meshParticles = new THREE.Points(
                particleGeometry,
                window.molematerial
              );
              meshParticles.position.x = -80;
              _this.scene.add(meshParticles);
            } else if (modalName == "//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/try_4.glb") {
              _this.Shadermaterialx = [];
              for (
                let index = 0;
                index < gltf.scene.children[0].children.length;
                index++
              ) {
                let name = gltf.scene.children[0].children[index].name;
                if (
                  name == "new-male-char-2_1" ||
                  name == "new-male-char-2_4" ||
                  name == "new-male-char-2_2"
                ) {
                  _this.Shadermaterialx[index] = new THREE.ShaderMaterial({
                    uniforms: {
                      uTime: { value: 0.1 },
                      uScale: { value: 1.0 },
                      uColor: { value: 1.0 },
                      uOpacity: { value: 0.0 },
                    },
                    vertexShader: ` attribute vec3 aRandom;
                                uniform float uTime;
                                uniform float uScale;
                                uniform float uColor;
                                varying vec3 vPosition;
                                void main() {
                                    vPosition = position;
                                    vec3 pos = position;
                                    float time = uTime * 0.5;
        
                                  vec4 mvPosition = modelViewMatrix * vec4(pos,1.0);
                                  gl_Position = projectionMatrix * mvPosition;
                                  gl_PointSize = 1.0;
                                }`,
                    fragmentShader: `varying vec3 vPosition;
                                uniform float uTime;
                                uniform float uColor;
                                uniform float uOpacity;
                                void main() {
                                     vec3 color = vec3(1.0,1.0,1.0); 
                                     color.r = uColor;
                                     color.g = 0.4313;
                                     color.b = 0.0;
                                    gl_FragColor = vec4(color,uOpacity); }`,
                    derivatives: true,
                    //blending:THREE.AdditiveBlending,
                    depthWrite: false,
                    transparent: true,
                    opacity: 0,
                    side: THREE.DoubleSide,
                  });
                } else {
                  _this.Shadermaterialx[index] = new THREE.ShaderMaterial({
                    uniforms: {
                      uTime: { value: 0.1 },
                      uScale: { value: 1.0 },
                      uColor: { value: 0.1 },
                      uGreen: { value: 0.1 },
                      uBlue: { value: 0.1 },
                    },
                    vertexShader: ` attribute vec3 aRandom;
                                uniform float uTime;
                                uniform float uScale;
                                uniform float uColor;
                                varying vec3 vPosition;
                                void main() {
                                    vPosition = position;
                                    vec3 pos = position;
                                    float time = uTime * 0.5;
                                    vec4 mvPosition = modelViewMatrix * vec4(pos,1.0);
                                    gl_Position = projectionMatrix * mvPosition;
                                    gl_PointSize = 1.0;
                                }`,
                    fragmentShader: `varying vec3 vPosition;
                                uniform float uTime;
                                uniform float uColor;
                                uniform float uGreen;
                                uniform float uBlue;
                                void main() {
                                     vec3 color = vec3(1.0,1.0,1.0); 
                                     color.r = uColor;
                                     color.g = uGreen;
                                     color.b = uBlue;
                                    gl_FragColor = vec4(color,1.0); }`,
                    derivatives: true,
                    depthWrite: false,
                    transparent: true,
                    opacity: 0,
                    side: THREE.DoubleSide,
                  });
                }
              }

              gltf.scene.children[0].children.forEach((obj, j) => {
                var model = obj;
                var meshParticles = new THREE.Points(
                  obj.geometry,
                  _this.Shadermaterialx[j]
                );
                meshParticles.scale.set(10, 10, 10);
                meshParticles.position.y = -20;

                let sampler = new THREE.MeshSurfaceSampler(obj).build();
                let numparticles = 20000;
                if (
                  obj.name == "new-male-char-2_1" ||
                  obj.name == "new-male-char-2_4" ||
                  obj.name == "new-male-char-2_2"
                ) {
                  numparticles = 10000;
                }
                let particleGeometry = new THREE.BufferGeometry();
                let particlePosition = new Float32Array(numparticles * 3);

                const vertices = [];
                const tempPosition = new THREE.Vector3();
                let particleRandomness = new Float32Array(numparticles * 3);
                for (let i = 0; i < numparticles; i++) {
                  sampler.sample(tempPosition);
                  vertices.push(tempPosition.x, tempPosition.y, tempPosition.z);
                  particleRandomness.set(
                    [
                      Math.random() * 2 - 1,
                      Math.random() * 2 - 1,
                      Math.random() * 2 - 1,
                    ],
                    i * 3
                  );
                }
                particleGeometry.setAttribute(
                  "position",
                  new THREE.Float32BufferAttribute(vertices, 3)
                );
                particleGeometry.setAttribute(
                  "aRandom",
                  new THREE.Float32BufferAttribute(particleRandomness, 3)
                );

                const materialx = new THREE.MeshStandardMaterial({
                  color: 0xff0000,
                  metalness: 0,
                  roughness: 1,
                  wireframe: true,
                  transparent: true,
                });

                gltf.scene.children[0].children.map(function (o) {
                  const materialx = new THREE.MeshStandardMaterial({
                    color: 0x000000,
                    metalness: 0.5,
                    roughness: 0.5,
                  });
                  if (o.isMesh) {
                    o.material = materialx;
                  }
                });
                var meshParticles = new THREE.Points(
                  particleGeometry,
                  _this.Shadermaterialx[j]
                );
                meshParticles.frustumCulled = false;
                _this.scene.add(meshParticles);
                particleGeometry.scale(1.7, 1.7, 1.7);
                meshParticles.position.set(0, -250, 0);
                if (jQuery(window).width() <= 1500) {
                  particleGeometry.scale(0.7, 0.7, 0.7);
                  meshParticles.position.set(0, -180, 0);
                }

                meshParticles.rotation.x = 1.6;
              });
            }
            if (modalName == "//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/car_try.glb") {
              _this.Shadermaterialcar = [];
              for (let index = 0; index < gltf.scene.children.length; index++) {
                _this.Shadermaterialcar[index] = new THREE.ShaderMaterial({
                  uniforms: {
                    uTime: { value: 0.1 },
                    uScale: { value: 1.0 },
                    uColor: { value: 1.0 },
                    uOpacity: { value: 0.0 },
                  },
                  vertexShader: ` attribute vec3 aRandom;
                            uniform float uTime;
                            uniform float uScale;
                            uniform float uColor;
                            varying vec3 vPosition;
                            void main() {
                                vPosition = position;
                                vec3 pos = position;
                                float time = uTime * 0.5;
    
                              vec4 mvPosition = modelViewMatrix * vec4(pos,1.0);
                              gl_Position = projectionMatrix * mvPosition;
                              gl_PointSize = 1.0;
                            }`,
                  fragmentShader: `varying vec3 vPosition;
                            uniform float uTime;
                            uniform float uColor;
                            uniform float uOpacity;
                            void main() {
                                 vec3 color = vec3(1.0,1.0,1.0); 
                                 color.r = 0.5;
                                 color.g = 0.5;
                                 color.b = 0.5;
                                gl_FragColor = vec4(color,uOpacity); }`,
                  derivatives: true,
                  //blending:THREE.AdditiveBlending,
                  depthWrite: false,
                  transparent: true,
                  opacity: 0,
                  side: THREE.DoubleSide,
                });
                var name = gltf.scene.children[index].name;
                if (
                  name == "seat4" ||
                  name == "ac" ||
                  name == "bottom" ||
                  name == "top1"
                ) {
                  _this.Shadermaterialcar[index] = new THREE.ShaderMaterial({
                    uniforms: {
                      uTime: { value: 0.1 },
                      uScale: { value: 1.0 },
                      uColor: { value: 1.0 },
                      uGreen: { value: 0.0 },
                      uOpacity: { value: 0.0 },
                    },
                    vertexShader: ` attribute vec3 aRandom;
                                uniform float uTime;
                                uniform float uScale;
                                uniform float uColor;
                                varying vec3 vPosition;
                                void main() {
                                    vPosition = position;
                                    vec3 pos = position;
                                    float time = uTime * 0.5;
        
                                  vec4 mvPosition = modelViewMatrix * vec4(pos,1.0);
                                  gl_Position = projectionMatrix * mvPosition;
                                  gl_PointSize = 1.0;
                                }`,
                    fragmentShader: `varying vec3 vPosition;
                                uniform float uTime;
                                uniform float uColor;
                                uniform float uOpacity;
                                uniform float uGreen;
                                void main() {
                                     vec3 color = vec3(1.0,1.0,1.0); 
                                     color.r = uColor;
                                     color.g = uGreen;
                                     color.b = 0.0;
                                    gl_FragColor = vec4(color,uOpacity); }`,
                    derivatives: true,
                    //blending:THREE.AdditiveBlending,
                    depthWrite: false,
                    transparent: true,
                    opacity: 0,
                    side: THREE.DoubleSide,
                  });
                }
              }

              window.meshParticless = [];
              gltf.scene.children.forEach((obj, j) => {
                let sampler = new THREE.MeshSurfaceSampler(obj).build();
                let numparticles = 30000;
                let particleGeometry = new THREE.BufferGeometry();
                let particlePosition = new Float32Array(numparticles * 3);
                if (obj.name == "ac") {
                  numparticles = 5000;
                }
                if (jQuery(window).width() <= 767) {
                  numparticles = 5000;
                }
                const vertices = [];
                const tempPosition = new THREE.Vector3();
                let particleRandomness = new Float32Array(numparticles * 3);
                for (let i = 0; i < numparticles; i++) {
                  sampler.sample(tempPosition);
                  vertices.push(tempPosition.x, tempPosition.y, tempPosition.z);
                  particleRandomness.set([1, 1, 1], i * 3);
                }
                particleGeometry.setAttribute(
                  "position",
                  new THREE.Float32BufferAttribute(vertices, 3)
                );
                particleGeometry.setAttribute(
                  "aRandom",
                  new THREE.Float32BufferAttribute(particleRandomness, 3)
                );
                var meshParticles = new THREE.Points(
                  particleGeometry,
                  _this.Shadermaterialcar[j]
                );
                _this.scene.add(meshParticles);
                meshParticles.position.set(0, -20, 0);
                meshParticles.scale.set(0.7, 0.7, 0.7);
                if (jQuery(window).width() <= 1600) {
                  meshParticles.scale.set(0.5, 0.5, 0.5);
                }
                // if(jQuery(window).width()<=767)
                // {
                //     _this.camera.zoom = 1;
                //     meshParticles.scale.set(.5,.5,.5)
                // }
                var tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });
                var tl2 = gsap.timeline({ repeat: -1, repeatDelay: 0 });
                tl.to(_this.carSeatColor, 1, { x: 1, y: 1, z: 0.43 }, 0);
                tl.to(_this.carSeatColor, 1, { x: 0, y: 0.1, z: 0 }, 1);
                tl.to(_this.carAcColor, 1, { x: 1, y: 1, z: 0.43 }, 2);
                tl.to(_this.carAcColor, 1, { x: 0, y: 0.1, z: 0 }, 3);
                tl.to(_this.RoofTopColor, 1, { x: 1, y: 1, z: 0.43 }, 4);
                tl.to(_this.RoofTopColor, 1, { x: 0, y: 0.1, z: 0.0 }, 5);
                tl.to(_this.carBottomColor, 1, { x: 1, y: 1, z: 0.43 }, 6);
                tl.to(_this.carBottomColor, 1, { x: 0, y: 0.1, z: 0.0 }, 7);
                tl2.to(
                  meshParticles.rotation,
                  18,
                  { y: 6.285, ease: "none" },
                  0
                );
                window.meshParticless.push(meshParticles);
              });
            }
            if (modalName == "https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb") {
              _this.scene.add(gltf.scene);
              gltf.scene.position.y = -50;
              gltf.scene.children[0].children.map(function (o) {
                const materialx = new THREE.MeshStandardMaterial({
                  color: 0x000000,
                  metalness: 0.5,
                  roughness: 0.5,
                });
                if (o.isMesh) {
                  o.material = materialx;
                }
              });
            }
          },
          function (xhr) { },
          function (error) {
            console.log("An error happened");
          }
        );
      });

      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(
        this.container.clientWidth,
        this.container.clientHeight
      );
      this.container.appendChild(this.renderer.domElement);
      if (
        jQuery(".single-product").length >= 1 ||
        jQuery(".page-template-science").length >= 1
      ) {
        this.controls = new THREE.OrbitControls(
          _this.camera,
          _this.renderer.domElement
        );
        this.controls.enableDamping = true;
        this.controls.enableZoom = false;
        this.controls.rotateSpeed = 0.1;
        this.controls.dampingFactor = 0.05;
        this.controls.minPolarAngle = Math.PI / 2;
        this.controls.maxPolarAngle = Math.PI / 2;
        this.controls.autoRotate = true;
        this.controls.autoRotateSpeed = 0.1;
        this.controls.enableKeys = false;
      }
    }
    onWindowResize() {
      var _this = this;
      _this.camera.aspect =
        _this.container.clientWidth / _this.container.clientHeight;
      this.renderer.setSize(
        _this.container.clientWidth,
        _this.container.clientHeight
      );
      _this.camera.updateProjectionMatrix();
    }
    onDocumentMouseMove(event) {
      var _this = this;
      _this.mouseX = event.clientX - _this.windowHalfX;
      _this.mouseY = event.clientY - _this.windowHalfY;
      if (window.footer_logo) {
        gsap.to(window.footer_logo.rotation, {
          y: gsap.utils.mapRange(
            0,
            window.innerWidth,
            0.5,
            -0.5,
            event.clientX
          ),
          x: gsap.utils.mapRange(
            0,
            window.innerHeight,
            0.5,
            -0.5,
            event.clientY
          ),
        });
      }
    }
    animate() {
      var _this = this;
      if (_this.controls) {
        _this.controls.update();
      }
      if (jQuery(window).width() > 1200) {
        if (_this.pointsMaterial) {
          var time = Date.now() * 0.00002;
          _this.pointsMaterial.uniforms.uTime.value =
            _this.clock.getElapsedTime();
        }
        if (_this.Shadermaterialx) {
          _this.Shadermaterialx.map(function (element, j) {
            _this.Shadermaterialx[2].uniforms.uColor.value = _this.bodyColor.x;
            _this.Shadermaterialx[2].uniforms.uGreen.value = _this.bodyColor.y;
            _this.Shadermaterialx[2].uniforms.uBlue.value = _this.bodyColor.z;
            _this.Shadermaterialx[0].uniforms.uColor.value = _this.lungsColor.x;
            _this.Shadermaterialx[0].uniforms.uOpacity.value =
              _this.lungsColor.y;
            _this.Shadermaterialx[1].uniforms.uColor.value = _this.heartColor.x;
            _this.Shadermaterialx[1].uniforms.uOpacity.value =
              _this.heartColor.y;
            _this.Shadermaterialx[3].uniforms.uColor.value = _this.braincolor.x;
            _this.Shadermaterialx[3].uniforms.uOpacity.value =
              _this.braincolor.y;
          });
          if (window.molematerial) {
            window.molematerial.uniforms.uTime.value =
              _this.clock.getElapsedTime();
          }
        }
        if (_this.Shadermaterialcar) {
          _this.Shadermaterialcar.forEach((element, j) => {
            // _this.Shadermaterialcar[j].uniforms.uTime.value = _this.clock.getElapsedTime()
            _this.Shadermaterialcar[j].uniforms.uScale.value =
              _this.humanpointsMaterialScale.x;
            _this.Shadermaterialcar[j].uniforms.uColor.value = 1.0;
            _this.Shadermaterialcar[j].uniforms.uOpacity.value = 1.0;
            _this.Shadermaterialcar[2].uniforms.uColor.value =
              _this.carAcColor.x;
            _this.Shadermaterialcar[2].uniforms.uOpacity.value =
              _this.carAcColor.y;
            _this.Shadermaterialcar[2].uniforms.uGreen.value =
              _this.carAcColor.z;
            _this.Shadermaterialcar[3].uniforms.uColor.value =
              _this.carBottomColor.x;
            _this.Shadermaterialcar[3].uniforms.uOpacity.value =
              _this.carBottomColor.y;
            _this.Shadermaterialcar[3].uniforms.uGreen.value =
              _this.carBottomColor.z;
            _this.Shadermaterialcar[4].uniforms.uColor.value =
              _this.carSeatColor.x;
            _this.Shadermaterialcar[4].uniforms.uOpacity.value =
              _this.carSeatColor.y;
            _this.Shadermaterialcar[4].uniforms.uGreen.value =
              _this.carSeatColor.z;
            _this.Shadermaterialcar[5].uniforms.uColor.value =
              _this.RoofTopColor.x;
            _this.Shadermaterialcar[5].uniforms.uOpacity.value =
              _this.RoofTopColor.y;
            _this.Shadermaterialcar[5].uniforms.uGreen.value =
              _this.RoofTopColor.z;
            _this.Shadermaterialcar[6].uniforms.uColor.value =
              _this.carBodyColor.x;
            _this.Shadermaterialcar[6].uniforms.uOpacity.value =
              _this.carBodyColor.y;
            _this.Shadermaterialcar[1].uniforms.uColor.value =
              _this.carBodyColor.x;
            _this.Shadermaterialcar[1].uniforms.uOpacity.value =
              _this.carBodyColor.y;
            _this.Shadermaterialcar[0].uniforms.uColor.value =
              _this.carBodyColor.x;
            _this.Shadermaterialcar[0].uniforms.uOpacity.value =
              _this.carBodyColor.y;
            //    console.log(j)
          });
        }
      }
      if (jQuery(window).width() > 1200) {
        requestAnimationFrame(() => this.animate());
      }
      _this.render();
    }
    render() {
      if (this.controls) {
        this.controls.update();
      }

      this.camera.lookAt(this.scene.position);
      this.renderer.render(this.scene, this.camera);
    }
    destroy() {
      this.Shadermaterialx = null;
      this.Shadermaterialcar = null;
      this.camera = null;
      this.scene = null;
      this.renderer = null;
      this.container = null;
      this.controls = null;
      this.modal = null;
      this.pointsMaterial = null;
      this.humanpointsMaterial = null;
      this.group = null
      this.clock = null;
      this.loader = null;
      this.dracoLoader = null;
      this.human = null;
      this.humanOpacity = null;
      this.humanpointsMaterialScale = null;
      this.productPageModal = null;
      this.Shadermaterialx = null;
      this.init = () => { }
      this.initWithParticle = () => { }
      this.animate = () => { }
      this.render = () => { }
      this.onWindowResize = () => { }
      this.onDocumentMouseMove = () => { }
    }
  }
  if (
    jQuery(window).width() <= 1200 &&
    jQuery(".homepage-tilt-img").length >= 1
  ) {
    window.home_page_mobile = new Load3DModal(".homepage-tilt-img");
    window.home_page_mobile.init("https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb");
    window.home_page_mobile.animate();
    window.addEventListener("resize", function () {
      window.home_page_mobile.onWindowResize();
    });
  }
  if (jQuery("#product360").length >= 1) {
    window.productPageModal = new Load3DModal("#product360");
    window.productPageModal.init("https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb");
    window.productPageModal.animate();
    window.addEventListener("resize", function () {
      window.productPageModal.onWindowResize();
    });
  }
  if (jQuery(".contact-page-modal").length >= 1) {
    window.contactPageModal = new Load3DModal(".contact-page-modal");
    window.contactPageModal.init("https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb");
    window.contactPageModal.animate();
    window.addEventListener("resize", function () {
      window.contactPageModal.onWindowResize();
    });
  }
  if (jQuery(".product-modal").length >= 1) {
    window.contactPageModal2 = null;
    window.contactPageModal2 = new Load3DModal(".product-modal");
    window.contactPageModal2.init("https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb");
    window.contactPageModal2.animate();
    window.addEventListener("resize", function () {
      window.contactPageModal2.onWindowResize();
    });
  }
  if (jQuery(".picture-flex-inner").length >= 1) {
    window.homePageModal2 = null;
    window.homePageModal2 = new Load3DModal(".picture-flex-inner");
    window.homePageModal2.init("https://cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/2_aaaa.glb");
    window.homePageModal2.animate();
    window.addEventListener("resize", function () {
      window.homePageModal2.onWindowResize();
    });

    if (jQuery(".product-intro").length >= 1 && jQuery(window).width() > 1200) {
      let knowsmokeSlides = jQuery(".content-slide");
      let scrollPercent = knowsmokeSlides.length * 100;
      let svgend = (knowsmokeSlides.length - 2 + 1) * 100;
      window.scrollxPercentformodal =
        ((knowsmokeSlides.length - 1) / 2 + 1) * 100;
      window.knowsmokeSlider = gsap.to(".knowsmoke-test-slider", {
        scrollTrigger: {
          trigger: ".knowsmoke-test-slider",
          scroller: "[data-scroll-container]",
          scrub: true,
          //   pin:true,
          start: "top top",
          end: "+=" + scrollPercent + "%",
        },
        ease: "none",
      });
      let windowHeight = jQuery(window).innerHeight();
      let knowsmokeSliderx = gsap.to(".picture-flex-inner", {
        scrollTrigger: {
          trigger: ".product-intro",
          scroller: "[data-scroll-container]",
          scrub: true,
          start: window.product_intro.scrollTrigger.end - windowHeight + 500,
          end: window.product_intro.scrollTrigger.end,
        },
        opacity: 1,
        ease: "none",
      });

      gsap.to(".content-slider", {
        scrollTrigger: {
          trigger: ".content-slider",
          scroller: "[data-scroll-container]",
          scrub: true,
          pin: true,
          start: "top top",
          end: knowsmokeSlider.scrollTrigger.end,
        },
        ease: "none",
      });

      let totalslideArea =
        knowsmokeSlider.scrollTrigger.end - knowsmokeSlider.scrollTrigger.start;
      let singleSlideTime = totalslideArea / knowsmokeSlides.length;
      let sliderStart = knowsmokeSlider.scrollTrigger.start;
    }
  }
  if (jQuery(".hero-particles").length >= 1) {
    window.hero_particle = null;
    window.hero_particle = new Load3DModal(".hero-particles");
    window.hero_particle.initWithParticle(["mole"]);
    window.hero_particle.animate();
    window.addEventListener("resize", function () {
      window.hero_particle.onWindowResize();
    });

  }
  if (jQuery(".car-video").length >= 1 && jQuery(window).width() > 1200) {
    window.science_pge = null;
    window.science_pge = new Load3DModal(".car-video");
    window.science_pge.initWithParticle(["//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/car_try.glb"]);
    window.science_pge.animate();
    window.addEventListener("resize", function () {
      window.science_pge.onWindowResize();
    });
    
  }
  if (jQuery(".body-video").length >= 1 && jQuery(window).width() > 1200) {
    window.body_video = null;
    window.body_video = new Load3DModal(".body-video");
    window.body_video.initWithParticle(["//cdn.shopify.com/s/files/1/0734/3059/7943/t/1/assets/try_4.glb"]);
    window.body_video.animate();
    window.addEventListener("resize", function () {
      window.body_video.onWindowResize();
    });
  }
}
function onWindowResize() {
  if (window.scrollx) {

    window.scrollx.update();
    ScrollTrigger.addEventListener("refresh", () => window.scrollx.update());
    ScrollTrigger.refresh();
  }

}
function formReinit() {
  if (typeof wc_add_to_cart_variation_params !== 'undefined') {
    $('.variations_form').each(function () {
      $(this).wc_variation_form();
    });
  }
}
window.addEventListener("resize", onWindowResize())
function init() {
  if (jQuery(".shopify-challenge__button").length >= 1) {
    jQuery(".shopify-challenge__button").after('<button type="submit" style="margin-left:auto;margin-right:auto;" class="o-button btn-primary btn wpcf7-form-control shopify-challenge__buttonx"><i class="button__bg"></i><span>Submit</span></button>');
    jQuery(".shopify-challenge__button").remove();

  }
  gsap.registerPlugin(ScrollTrigger);
  $("input[type=tel]").keypress(function (eve) {
    if (
      ((eve.which != 46 || $(this).val().indexOf(".") != -1) &&
        (eve.which < 48 || eve.which > 57)) ||
      (eve.which == 46 && $(this).caret().start == 0)
    ) {
      eve.preventDefault();
    }
    // this part is when left part of number is deleted and leaves a . in the leftmost position. For example, 33.25, then 33 is deleted
    $("input[type=tel]").keyup(function (eve) {
      if ($(this).val().indexOf(".") == 0) {
        $(this).val($(this).val().substring(1));
      }
    });
  });

  if (jQuery(".wpcf7").length >= 1) {
    var wpcf7Elm = document.querySelector(".wpcf7");
    wpcf7Elm.addEventListener(
      "wpcf7submit",
      function (event) {
        setTimeout(() => {
          window.scrollx.update();
        }, 2000);
      },
      false
    );
  }
  jQuery(".reset-scroll").on("click", function () {
    setTimeout(() => {
      window.scrollx.update();
    }, 500);
  })
  if (jQuery("#place_order").length >= 1) {
    $(document.body).on("checkout_error", function () {
      setTimeout(() => {
        window.scrollx.update();
      }, 500);
    });
  }

  jQuery("[data-target]").on("click", function () {
    let target = jQuery(this).attr("data-target");
    jQuery(target).addClass("show");

    let src = jQuery(".reel-video-c iframe").attr("data-src");
    jQuery(".reel-video-c iframe").attr("src", src);
  });
  jQuery(document).on("click", ".close-a", function (e) {
    jQuery(".reel-video-c iframe").attr("src", "");
    jQuery(".reel-video-c").removeClass("show");
  });
  jQuery(document).on(
    "change",
    "#ship-to-different-address-checkbox",
    function () {
      setTimeout(() => {
        window.scrollx.update();
      }, 500);
    }
  );
  jQuery(".showlogin").on("click", function () {
    setTimeout(() => {
      window.scrollx.update();
    }, 1000);
  });
  jQuery(document).ready(function () {
    
    // jQuery(".footer-toggle").on("click", function (e) {
    //   jQuery(e.target).next().slideToggle();
    //   jQuery(e.target).next().toggleClass("active");
    //   jQuery(e.target).toggleClass("active");
    // });
    document.body.classList.forEach(function (cls) {
      document.body.classList.remove(cls)
    })
    document.body.classList.add("loaded")
    let body_class = document.querySelector("main").classList.forEach(function (cls) {
      document.body.classList.add(cls)
    })
    jQuery("body").addClass(body_class)
    jQuery("a").on("click", function (e) {
      if (jQuery(this).attr("href") == "#") e.preventDefault();
    });
    jQuery("button[type=submit]").on("click", function () {
      jQuery(".wpcf7-not-valid-tip").remove();
    });
    if (jQuery(".testimonail-slider").length >= 1) {
      new Swiper(".testimonail-slider", {
        navigation: {
          nextEl: ".owl-nav-prevx",
          prevEl: ".owl-nav-nextx",
        },
        slidesPerView: 1.3,
        spaceBetween: 50,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          1000: {
            slidesPerView: 1.3,
            spaceBetween: 40,
          },
        },
      });
    }
    if (jQuery(".use-slider").length >= 1) {
      let use_slider = new Swiper(".use-slider", {
        effect: 'fade',
        slidesPerView: 1,
        spaceBetween: 50,
      });

      jQuery(".use-slider .owl-dots .owl-dot").addClass("active");
      window.scrollx.on("scroll", function () {
        let progress = window.u_tl.scrollTrigger.progress
        if (progress >= 0.01 && progress <= 0.33) {
          use_slider.slideTo(1)
          jQuery(".use-slider .owl-dots .owl-dot").removeClass("active");
          jQuery(".use-slider .owl-dots .owl-dot.owl-dot-1").addClass("active");
        }
        else if (progress >= 0.34 && progress <= 0.66) {
          use_slider.slideTo(2)
          jQuery(".use-slider .owl-dots .owl-dot").removeClass("active");
          jQuery(".use-slider .owl-dots .owl-dot.owl-dot-2").addClass("active");
        }
        else if (progress >= 0.67 && progress <= 1) {
          use_slider.slideTo(3)
          jQuery(".use-slider .owl-dots .owl-dot").removeClass("active");
          jQuery(".use-slider .owl-dots .owl-dot.owl-dot-3").addClass("active");
        }
        else {
          jQuery(".use-slider .owl-dots .owl-dot").removeClass("active");
        }
      })
      var timeintervalx = 2500;
      use_slider.on("slideChange", function (e) {
        if (use_slider.activeIndex == 1) {
          document.querySelector(".product-steps-new video").currentTime = 0;
          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("play");
          }, 500);
          timeintervalx = 2500;
          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("pause");
          }, timeintervalx);
        } else if (use_slider.activeIndex == 2) {
          document.querySelector(".product-steps-new video").currentTime = 2.5;
          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("play");
          }, 500);
          timeintervalx = 3500;
          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("pause");
          }, timeintervalx);
        } else if (use_slider.activeIndex == 3) {
          document.querySelector(".product-steps-new video").currentTime = 6;
          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("play");
          }, 500);
          timeintervalx = 13000;

          setTimeout(() => {
            jQuery(".product-steps-new video").trigger("pause");
          }, timeintervalx);
        }
      });
    }
    if (jQuery(".product-slide").length >= 1) {
      new Swiper(".product-slider", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
      });
    }
    if (jQuery(".product-gallery-slider").length >= 1) {
      new Swiper(".product-gallery-slider", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        slidesPerView: 1,
      });
    }
    if (jQuery(".body-slider").length >= 1) {
      let body_slider = new Swiper(".body-slider", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
      });
      body_slider.on("slideChange", function (e) {
        jQuery(".male-modal video").removeClass("active");
        if (body_slider.activeIndex == 0) {
          jQuery(".male-modal video").eq(0).addClass("active");
        } else if (body_slider.activeIndex == 1) {
          jQuery(".male-modal video").eq(1).addClass("active");
        } else if (body_slider.activeIndex == 2) {
          jQuery(".male-modal video").eq(2).addClass("active");
        } else if (body_slider.activeIndex == 3) {
          jQuery(".male-modal video").eq(3).addClass("active");
        }
      });
    }
    if (jQuery(".step-slider.swiper").length >= 1) {
      let step_slider = new Swiper(".step-slider.swiper", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        autoHeight: true,
      });
      var timeintervalx = 2500;
      step_slider.on("slideChange", function (e) {
        if (step_slider.activeIndex == 0) {
          document.querySelector(".steps-slider video").currentTime = 0;
          setTimeout(() => {
            jQuery(".steps-slider video").trigger("play");
          }, 500);
          timeintervalx = 2500;
          setTimeout(() => {
            jQuery(".steps-slider video").trigger("pause");
          }, timeintervalx);
        } else if (step_slider.activeIndex == 1) {
          document.querySelector(".steps-slider video").currentTime = 2.5;
          setTimeout(() => {
            jQuery(".steps-slider video").trigger("play");
          }, 500);
          timeintervalx = 3500;
          setTimeout(() => {
            jQuery(".steps-slider video").trigger("pause");
          }, timeintervalx);
        } else if (step_slider.activeIndex == 2) {
          document.querySelector(".steps video").currentTime = 6;
          setTimeout(() => {
            jQuery(".steps-slider video").trigger("play");
          }, 500);
          timeintervalx = 13000;

          setTimeout(() => {
            jQuery(".steps-slider video").trigger("pause");
          }, timeintervalx);
        }
      });
    }
    if (jQuery(".blog-slider").length >= 1) {
      var blogs_slider;
      blogs_slider = new Swiper(".blog-slider", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
      blogs_slider.on("slideChange", function (e) {
        if (blogs_slider.activeIndex >= 1) {
          jQuery(".blogs-list .title").addClass("invisible");
          jQuery(".blogs-list .owl-nav .owl-prev").addClass("visible");
        } else {
          jQuery(".blogs-list .title").removeClass("invisible");
          jQuery(".blogs-list .owl-nav .owl-prev").removeClass("visible");
        }
      });
    }

    $(".testimonials .owl-nav-nextx").click(function () {
      jQuery(".testimonials .owl-prev").trigger("click");
    });
    $(".owl-nav-prevx").click(function () {
      jQuery(".testimonials .owl-next").trigger("click");
    });

    if (jQuery(".page-template-partnership").length >= 1) {
      document
        .querySelector(".about-hero video")
        .addEventListener("ended", function (e) {
          jQuery(".about-hero [data-scroll-x]").addClass("is-inview");
          setTimeout(() => {
            jQuery(".about-hero").addClass("pb-sm-100");
          }, 500);
          jQuery(
            ".about-hero .container .right-side .flex .hero-link li a"
          ).css("border-bottom", "1px solid #ff6e00");
        });
    }

    if (document.querySelectorAll(".home-hero").length >= 1) {
      setTimeout(() => {
        document
          .querySelectorAll(".home-hero [data-scroll-x]")
          .forEach(function (e) {
            e.classList.add("is-inview");
          });
      }, 1500);
      if (document.querySelectorAll(".home-hero video.lg-hide").length >= 1) {
        document.querySelector(".home-hero video.lg-hide").onplay =
          function () {
            setTimeout(() => {
              document.querySelectorAll(".home-hero img").forEach(function (e) {
                e.remove();
              });
            }, 500);
          };
      }
    }

    jQuery(".faq-sidebar ul li a").on("click", function () {
      jQuery(".faq-sidebar ul li a").removeClass("active");
      jQuery(this).addClass("active");
    });

    jQuery(".sidebar .sidebar-header .close").on("click", function () {
      jQuery(".sidebar").removeClass("view");
      jQuery(".sidebar-overlay").removeClass("view");
      jQuery("body").removeClass("sidebar-opened");
      jQuery(".sidebar .sidebar-content").removeClass("initialized");
      jQuery(".sidebar .loading").removeClass("initialized");
    });
  });
  if (jQuery(".steps-slider video").length >= 1) {
    document.querySelector(".steps-slider video").currentTime = 0;
    document.querySelector(".steps-slider video").play();
    setTimeout(() => {
      document.querySelector(".steps-slider video").pause();
    }, 2500);
  }

  jQuery("[data-sidebar]").on("click", function () {
    let sidebar_ID = jQuery(this).attr("data-sidebar");
    $.get(
      window.shop_url + "/pages/" + sidebar_ID+".json",
      function (data, status) {
        jQuery(".sidebar .sidebar-content").scrollTop(0)
        jQuery(".sidebar .sidebar-content .title").html(data.page.title);
        jQuery(".sidebar .sidebar-content .content .desc").html(
          data.page.body_html
        );
        jQuery(".sidebar .sidebar-content").addClass("initialized");
        jQuery(".sidebar .loading").addClass("initialized");
      }
    );
    jQuery(".sidebar").addClass("view");
    jQuery("body").addClass("sidebar-opened");
    jQuery(".sidebar-overlay").addClass("view");
  });
  jQuery(".sidebar-overlay").on("click", function () {
    jQuery(".sidebar").removeClass("view");
    jQuery("body").removeClass("sidebar-opened");
    jQuery(".sidebar-overlay").removeClass("view");
    jQuery(".sidebar .sidebar-content").removeClass("initialized");
    jQuery(".sidebar .loading").removeClass("initialized");
  });

  $(".accordions p:empty").remove();

  jQuery(".accordion").on("click", function () {
    jQuery(this).find(".answer").slideToggle();
  });



  document.body.addEventListener("mousemove", (event) => {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    gsap.to(".shape", 0.02, {
      x: mouseX - jQuery(".shape").width() / 2,
      y: mouseY - jQuery(".shape").width() / 2,
      stagger: -0.1,
    });
  });
  jQuery("[data-cursor]").on("mouseenter", function () {
    let button_text = jQuery(this).attr("data-cursor");
    if (button_text) {
      jQuery(".shape").html(button_text);
    }
    gsap.to(".shape", 0.3, {
      opacity: 1,
      scale: 1,
    });
  });
  jQuery("[data-cursor]").on("mouseleave", function () {
    gsap.to(".shape", 0.3, {
      opacity: 0,
      scale: 0,
    });
  });
  jQuery("[data-cursor=Play]").on("click", function (e) {
    let video_intro_src = jQuery(this).attr("data-intro-src");
    let video_full_src = jQuery(this).attr("data-src");
    let video = e.target;
    if (jQuery(this).hasClass("playing")) {
      jQuery(this).attr("src", video_intro_src);
      jQuery(this).removeClass("playing");
      video.muted = true;
      jQuery(".shape").html("Play");
    } else {
      jQuery(this).addClass("playing");
      jQuery(this).attr("src", video_full_src);
      video.muted = false;
      jQuery(".shape").html("Pause");
    }
  });
  jQuery(".calculator form span").on("click", function () {
    jQuery(".calculator form span").removeClass("selected");
    jQuery(this).addClass("selected");
  });
  jQuery(".calculator form button").on("click", function (e) {
    e.preventDefault();

    var val = jQuery(".calculator input").val();
    let off_value = 0;
    if (val <= 2499) {
      if (document.querySelector(".notice--wrapper")) {
        document.querySelector(".notice--wrapper").remove();
      }
      var element = document.querySelector(".depreciated_price");
      var newElement = document.createElement("div");
      newElement.classList.add("notice--wrapper");
      newElement.innerText = "Value must be greater than $2499";
      var elementParent = element.parentNode;
      elementParent.insertBefore(newElement, element.nextSibling);
    } else if (val < 25000) {
      if (document.querySelector(".notice--wrapper")) {
        document.querySelector(".notice--wrapper").remove();
      }
      jQuery(".depreciated_price p").html("500");
    } else {
      if (document.querySelector(".notice--wrapper")) {
        document.querySelector(".notice--wrapper").remove();
      }
      jQuery(".depreciated_price p").html((Number(val) * 2) / 100);
    }
  });
  jQuery(".testimonials-c").height(jQuery(".testimonials").innerHeight());

  if (jQuery(".page-template-about").length >= 1) {
    setTimeout(() => {
      jQuery("[data-scroll-x]").addClass("is-inview");
    }, 3000);
  }
  if (
    document.querySelectorAll(".page-template-about .about-hero").length >= 1
  ) {
    setTimeout(() => {
      document.querySelectorAll(".about-hero video").forEach(function (e) {
        e.play();
      });
    }, 1000);
  }
  if (
    document.querySelectorAll(".page-template-partnership .about-hero")
      .length >= 1
  ) {
    setTimeout(() => {
      document.querySelectorAll(".about-hero video").forEach(function (e) {
        e.play();
      });
    }, 1000);
  }
  setTimeout(() => {
    if (document.querySelectorAll(".home-hero video").length >= 1) {
      document.querySelectorAll(".home-hero video").forEach(function (e) {
        e.play();
      });
    }
  }, 3500);
  setTimeout(() => {
    if (document.querySelectorAll(".home-hero video").length >= 1) {
      if (jQuery(window).width() <= 1200) {
        let home_banner_video = document.querySelector(
          ".home-hero video.lg-hide"
        );
        setInterval(() => {
          if (home_banner_video.currentTime >= 18) {
            document
              .querySelectorAll(".homepage-hero-cont .h2")
              .forEach(function (e) {
                e.classList.add("text-dark");
              });
            document.querySelectorAll(".home-hero").forEach(function (e) {
              e.classList.add("bg-white");
            });
          } else {
            document
              .querySelectorAll(".homepage-hero-cont .h2")
              .forEach(function (e) {
                e.classList.remove("text-dark");
              });
            document.querySelectorAll(".home-hero").forEach(function (e) {
              e.classList.remove("bg-white");
            });
          }
        }, 33.33);
      } else {
        let home_banner_video = document.querySelector(".home-hero video");
        setInterval(() => {
          if (home_banner_video.currentTime >= 13) {
            document
              .querySelectorAll(".homepage-hero-cont .h2")
              .forEach(function (e) {
                e.classList.add("text-dark");
              });
            document.querySelectorAll(".home-hero").forEach(function (e) {
              e.classList.add("bg-white");
            });
          } else {
            document
              .querySelectorAll(".homepage-hero-cont .h2")
              .forEach(function (e) {
                e.classList.remove("text-dark");
              });
            document.querySelectorAll(".home-hero").forEach(function (e) {
              e.classList.remove("bg-white");
            });
          }
        }, 33.33);
      }
    }
  }, 1500);

  setTimeout(() => {
    if (document.querySelectorAll(".home-hero-slider .main").length >= 1) {
      document.querySelector(".home-hero-slider .main").classList.add("active");
    }
  }, 2000);

  if (document.querySelectorAll(".product-hero").length > 0) {
    setTimeout(() => {
      document.querySelector(".product-hero").classList.add("play");
      document.querySelector(".product-hero video").play();
      if (document.querySelector(".product-vid img")) {
        document.querySelector(".product-vid img").remove();
      }
    }, 2500);
  }
  jQuery(document).on("click", ".menu-toggler", function () {
    jQuery(".header-mobile").toggleClass("menu-opened");
    jQuery("body").toggleClass("menu-opened");
    jQuery(".menu-toggler").toggleClass("menu-opened");
  });


  $(document.body).on("updated_cart_totals", function () {
    var data = {
      action: "cart_count_retriever",
    };
    jQuery.post(window.custom_ajax_url, data, function (response) {
      jQuery("a.cart-menu span").html(response);
    });
  });
}

window.addEventListener("goto_cart", function () {
  barba.go(window.cart_url);
  var data = {
    action: "cart_count_retriever",
  };
  jQuery.post(window.custom_ajax_url, data, function (response) {
    jQuery("a.cart-menu span").html(response);
  });
});
window.addEventListener("DOMContentLoaded", function () {
  function barbaEnter() {
    const forms = document.querySelectorAll(".wpcf7 > form");
    forms.forEach((form) => wpcf7.init(form));
    document.querySelector(".header-mobile").classList.remove("menu-opened");
    document.querySelector("body").classList.remove("menu-opened");
    document.querySelectorAll(".menu-toggler").forEach(function (e) {
      e.classList.remove("menu-opened");
    });
    ScrollTrigger.addEventListener("refresh", () => window.scrollx.update());
    ScrollTrigger.refresh();
  }

  function delay(n) {
    n = n || 2000;
    return new Promise((done) => {
      setTimeout(() => {
        done();
      }, n);
    });
  }
  var timeinterval = 0; // for now
  barba.init({
    sync: true,
    debug: true,
    timeout: 7000,
    cacheIgnore: false,
    prefetchIgnore: true,
    prevent: ({ el }) => (1 == 1),
    transitions: [
      {
        name: "overlay-transition",
        cacheIgnore: ["/science"],
        debug: false,
        once(data) {
          
          preloader();
          callToBeOnce();
          init();
          document.fonts.ready.then(() => {
            // splitLines();
            scrollAnimation();
            animations();
            headerAnimation();
            scienceAnimation();
          });
        },
        async leave(data) {
          document.body.classList.forEach(function (cls) {
            document.body.classList.remove(cls)
          })
          if (window.home_page_mobile) {
            window.home_page_mobile.destroy();
          }
          if (window.productPageModal) {
            window.productPageModal.destroy();
          }
          if (window.contactPageModal) {
            window.contactPageModal.destroy();
          }
          if (window.contactPageModal2) {
            window.contactPageModal2.destroy();
          }
          if (window.homePageModal2) {
            window.homePageModal2.destroy();
          }
          if (window.hero_particle) {
            window.hero_particle.destroy();
          }
          if (window.science_pge) {
            window.science_pge.destroy();
          }
          if (window.body_video) {
            window.body_video.destroy()
          }
          timeinterval = new Date();
          const done = this.async();

          gsap.fromTo(
            ".page-transition",
            {
              y: "100%",
            },
            {
              y: "0px",
              duration: 0.5,
              ease: "expo.out",
            }
          );
          gsap.fromTo(
            ".page-transition div",
            {
              opacity: 0,
            },
            {
              y: 0,
              duration: 1,
              opacity: 1,
              ease: "expo.out",
              delay: .5,
            }
          );
          await delay(1000);
          data.current.container.remove();
          done();
        },
        async enter(data) {
          cf7srLoadCallback();
          init();
          setTimeout(() => {
            if (document.querySelectorAll(".home-hero video").length >= 1) {
              document.querySelectorAll(".home-hero video").forEach(function (e) {
                e.play();
              });
            }
          }, 2500);
          document.fonts.ready.then(() => {
            // splitLines();
            scrollAnimation();
            animations();
            headerAnimation();
            scienceAnimation();
          });
          setTimeout(() => {
            window.dispatchEvent(new Event("load"));
            barbaEnter();

            console.log(
              Math.abs(new Date().getTime() - timeinterval.getTime()) / 1000
            );
          }, 1000);
        },
        async beforeEnter(data) {

          if (document.querySelector(".sgr-main"))
            if (document.querySelector("main.woocommerce-cart")) {
              barba.force(window.home_url + "/cart")
            }
          ScrollTrigger.getAll().forEach((t) => t.kill());
          window.scrollx.destroy();
          setTimeout(() => {
            gsap.to(".page-transition", {
              y: "-100%",
              duration: 0.51,
              ease: "expo.in",
              delay: .3
            });
            gsap.to(".page-transition div", {
              duration: 0.5,
              opacity: 0,
              ease: "expo.out",
            });
          }, 1000);
        },
        async afterEnter() {


          var vids = document.querySelectorAll("video[autoplay]");
          vids.forEach((vid) => {
            var playPromise = vid.play();
            if (playPromise !== undefined) {
              playPromise.then((_) => { }).catch((error) => { });
            }
          });
          setTimeout(() => {
            window.scrollx.update();

            jQuery(document).on("click", ".menu-toggler", function () {
              jQuery(".header-mobile").toggleClass("menu-opened");
              jQuery("body").toggleClass("menu-opened");
              jQuery(".menu-toggler").toggleClass("menu-opened");

            });
          }, 500);

        },
      },
    ],
  });
});
